import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API_HOST } from "environments/environment";
import { Observable } from "rxjs";
import { DbNotification, NotificationType } from "fakturnia-shared";

/**
 * Interfejs odpowiedzi z listą powiadomień
 */
export interface NotificationsListResponse {
    notifications: DbNotification[];
    total: number;
    unreadCount: number;
}

/**
 * Interfejs odpowiedzi z liczbą nieprzeczytanych
 */
export interface UnreadCountResponse {
    unreadCount: number;
}

/**
 * Serwis API do zarządzania powiadomieniami
 * Endpointy: GET/PATCH/DELETE /v1/notifications
 */
@Injectable({
    providedIn: 'root'
})
export class NotificationsApiService {

    constructor(private http: HttpClient) { }

    /**
     * Pobiera listę powiadomień użytkownika
     * @param options Opcje filtrowania i paginacji
     */
    public getNotifications(options: {
        limit?: number;
        offset?: number;
        unreadOnly?: boolean;
        types?: NotificationType[];
    } = {}): Observable<any> {
        const params: any = {};
        
        if (options.limit) params.limit = options.limit.toString();
        if (options.offset) params.offset = options.offset.toString();
        if (options.unreadOnly) params.unreadOnly = 'true';
        if (options.types && options.types.length > 0) {
            params.types = options.types.join(',');
        }

        return this.http.get(API_HOST + 'notifications', { params });
    }

    /**
     * Pobiera liczbę nieprzeczytanych powiadomień
     */
    public getUnreadCount(): Observable<any> {
        return this.http.get(API_HOST + 'notifications/unread-count');
    }

    /**
     * Oznacza pojedyncze powiadomienie jako przeczytane
     * @param notificationId ID powiadomienia
     */
    public markAsRead(notificationId: string): Observable<any> {
        return this.http.patch(API_HOST + `notifications/${notificationId}/read`, {});
    }

    /**
     * Oznacza wszystkie powiadomienia jako przeczytane
     */
    public markAllAsRead(): Observable<any> {
        return this.http.patch(API_HOST + 'notifications/read-all', {});
    }

    /**
     * Usuwa pojedyncze powiadomienie
     * @param notificationId ID powiadomienia
     */
    public deleteNotification(notificationId: string): Observable<any> {
        return this.http.delete(API_HOST + `notifications/${notificationId}`);
    }

    /**
     * Usuwa wszystkie powiadomienia
     */
    public deleteAllNotifications(): Observable<any> {
        return this.http.delete(API_HOST + 'notifications');
    }
}
